<template>
    <div class="row">
        <div class="sm-12">
            <p class="text-primary-darker-1 text-center">
                <strong>DESPESAS</strong>
            </p>
            <div class="responsive-table">

                <table>
                    <thead>
                        <tr>
                            <th align="left">DESCRIÇÃO</th>
                            <th align="right" width="200">VALOR(R$)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <Grupo :is_despesa="true" :grupo="grupo" v-for="grupo in despesas.Grupos" :key="grupo.id"></Grupo>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td align="right">
                                <strong>Total Despesas</strong>
                            </td>
                            <td align="right" width="200">
                                <strong class="text-red">{{ -despesas.ValorDespesas | number_format }}</strong>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import Grupo from './grupo.vue';
export default {
    props: ['despesas'],
    components: {
        Grupo
    },
    filters: {
        number_format(value) {
            return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value)
        }
    }
}
</script>